import AuthUtil from './authUtil'

import type { InternalAxiosRequestConfig } from 'axios'

/**
 * Request interceptor that attaches the Cognito idToken (raw, no `Bearer` prefix) as the
 * Authorization header when a user session exists — best-effort. Mirrors the native app's
 * comms client; the header is omitted when there is no session and the request still proceeds.
 */
export async function applyIdTokenAuthHeader(request: InternalAxiosRequestConfig) {
  const userSession = await AuthUtil.getUserSession()
  if (userSession?.idToken?.jwtToken) {
    request.headers.Authorization = `${userSession.idToken.jwtToken}`
  }
  return request
}
